const ROOMS_URL = 'https://rooms.zezamii.com';

/**
 * Launch the Rooms Dashboard (rooms.zezamii.com) from the product switcher / dashboard chooser.
 *
 * 🛑 THERE IS NO TOKEN HANDOFF, AND ADDING ONE BACK WOULD BREAK IT AGAIN. This used to mint a
 * Firebase ID token and pass it as `?token=`. Both halves of that are now wrong:
 *
 *   • This dashboard signs in through KINDE (see library/auth/authProvider.js — the C-2 login
 *     cutover). A Kinde session has no Firebase user at all, so `auth.currentUser` was null,
 *     `getCurrentUser()` resolved null, and the helper threw before opening anything.
 *   • Rooms never read `?token=`. Its only receiver, `receiveAuthToken` in
 *     redux/auth/helpers.js, is a postMessage listener nothing calls, with an allow-list of
 *     hostnames that do not exist. The parameter was ignored on arrival.
 *
 * Rooms is a Kinde-native SPA and a separate client on the SAME Kinde tenant as this dashboard,
 * sharing one SSO cookie — so it mints its own session with a silent /authorize bounce, exactly
 * like the Partner app. A plain navigation is the whole handoff. See openPartner.
 *
 * ⚠️ PRODUCTION-ONLY URL, unlike openPartner's env-aware host. Rooms has no non-prod custom
 * domain: its SWA (ZezamiiRoomsPlatform) serves `rooms.zezamii.com` from `prd` and a bare
 * `*.azurestaticapps.net` preview from `dev`. So from localhost or a dev build this lands on
 * PRODUCTION Rooms, whose Kinde tenant (auth.zezamii.com) is not the one a dev session holds —
 * expect Rooms' own login screen there rather than a silent sign-in.
 *
 * 🛑 New tab, and it is SAFE HERE ONLY BECAUSE THIS FUNCTION IS SYNCHRONOUS. A browser permits
 * `window.open` while it can still attribute it to the click on the stack. The old version
 * awaited a token first, which put the call in a later task with no gesture behind it, and the
 * popup blocker refused it silently — that was half of "clicking Rooms does nothing". Do not
 * reintroduce an `await` before this line; if Rooms ever needs something fetched, open the tab
 * first and set its location afterwards.
 *
 * `noopener` because Rooms has no use for a handle back: its only opener-dependent code path is
 * the dead `receiveAuthToken` listener described above.
 */
const openRooms = () => {
	window.open(ROOMS_URL, '_blank', 'noopener');
};

export default openRooms;
